import React from "react";
import "./Nineth.css";
import { Container } from "react-bootstrap";
import shopy from "../../../../Asset/d2c/Shopify.svg";
import woo from "../../../../Asset/d2c/woo.svg";
import vector from "../../../../Asset/d2c/Vector-1-1.svg";
import big from "../../../../Asset/d2c/Group-4.svg";
import hubspot from "../../../../Asset/d2c/Hubspot.svg";
import zoho from "../../../../Asset/d2c/zoho.svg";
import klaviyo from "../../../../Asset/d2c/Frame-1000004504.svg";
import sales from "../../../../Asset/d2c/salesforce.svg";
import wordpress from "../../../../Asset/d2c/tensorflow-icon-1-1.svg";
import wix from "../../../../Asset/d2c/pytorch-icon-1-1.svg";
import squarespace from "../../../../Asset/d2c/Keras_logo-1-1.svg";
import drupal from "../../../../Asset/d2c/icon-w-drupal-1.svg";
import mailchimp from "../../../../Asset/d2c/Group-1-1.svg";
import activeCampaign from "../../../../Asset/d2c/Frame-1000004505.svg";
import optinMonster from "../../../../Asset/d2c/Group-2906615.svg";
import omni from "../../../../Asset/d2c/Frame-1000004506.svg";
import googleAna from "../../../../Asset/d2c/Google-Analytics.svg";
import hotjar from "../../../../Asset/d2c/Hotjar.svg";
import mixpan from "../../../../Asset/d2c/MIXPANEL.svg";
import crazy from "../../../../Asset/d2c/crazyEgg.svg";
import paypal from "../../../../Asset/d2c/paypal.svg";
import strip from "../../../../Asset/d2c/strip.svg";
import razor from "../../../../Asset/d2c/rosarpay.svg";
import payU from "../../../../Asset/d2c/payu.svg";
import ccave from "../../../../Asset/d2c/ccAvanue.svg";
import cashFree from "../../../../Asset/d2c/cashFree.svg";
import zendesk from "../../../../Asset/d2c/zendesk.svg";
import freshdesk from "../../../../Asset/d2c/freshDesk.svg";
import intercom from "../../../../Asset/d2c/intercom.svg";
import tidio from "../../../../Asset/d2c/tidio.svg";
import face from "../../../../Asset/d2c/facebook-add.svg";
import insta from "../../../../Asset/d2c/insta.svg";
import gAdd from "../../../../Asset/d2c/google_ads.svg";
import godaddy from "../../../../Asset/d2c/goDaddy.svg";
import hostinger from "../../../../Asset/d2c/hostinger.svg";
import wpEngine from "../../../../Asset/d2c/wp.svg";
import siteGround from "../../../../Asset/d2c/site.svg";
import wpmu from "../../../../Asset/d2c/mpmuDev.svg";
import aws from "../../../../Asset/d2c/aws.svg";
import gcloud from "../../../../Asset/d2c/gCloude.svg";

const techData = [
  {
    category: "E-commerce Platforms",
    items: [
      { name: "Shopify", imgSrc: shopy },
      { name: "WooCommerce", imgSrc: woo },
      { name: "Webflow", imgSrc: vector },
      { name: "BigCommerce", imgSrc: big },
    ],
  },
  {
    category: "CRM",
    items: [
      { name: "Hubspot", imgSrc: hubspot },
      { name: "Zoho", imgSrc: zoho },
      { name: "Klaviyo", imgSrc: klaviyo },
      { name: "Salesforce", imgSrc: sales },
    ],
  },
  {
    category: "CMS",
    items: [
      { name: "WordPress", imgSrc: wordpress },
      { name: "Wix", imgSrc: wix },
      { name: "Squarespace", imgSrc: squarespace },
      { name: "Drupal", imgSrc: drupal },
    ],
  },
  {
    category: "Marketing Automation",
    items: [
      { name: "Mailchimp", imgSrc: mailchimp },
      { name: "ActiveCampaign", imgSrc: activeCampaign },
      { name: "OptinMonster", imgSrc: optinMonster },
      { name: "Omni send", imgSrc: omni },
    ],
  },
  {
    category: "Analytics & Personalization",
    items: [
      { name: "Google Analytics", imgSrc: googleAna },
      { name: "Hotjar", imgSrc: hotjar },
      { name: "Mixpanel", imgSrc: mixpan },
      { name: "Crazy Egg", imgSrc: crazy },
    ],
  },
  {
    category: "Payment Gateways",
    items: [
      { name: "PayPal", imgSrc: paypal },
      { name: "Stripe", imgSrc: strip },
      { name: "Razorpay", imgSrc: razor },
      { name: "PayU", imgSrc: payU },
      { name: "CCAvenue", imgSrc: ccave },
      { name: "Cashfree", imgSrc: cashFree },
    ],
  },
  {
    category: "Customer Support",
    items: [
      { name: "Zendesk", imgSrc: zendesk },
      { name: "Freshdesk", imgSrc: freshdesk },
      { name: "Intercom", imgSrc: intercom },
      { name: "Tidio", imgSrc: tidio },
    ],
  },
  {
    category: "Social Media & Advertising",
    items: [
      { name: "Facebook Ads", imgSrc: face },
      { name: "Instagram Shopping", imgSrc: insta },
      { name: "Google Ads", imgSrc: gAdd },
    ],
  },
  {
    category: "Website Hosting & CDN",
    items: [
      { name: "GoDaddy", imgSrc: godaddy },
      { name: "Hostinger", imgSrc: hostinger },
      { name: "WP Engine", imgSrc: wpEngine },
      { name: "Site Ground", imgSrc: siteGround },
      { name: "WPMU DEV", imgSrc: wpmu },
      { name: "AWS", imgSrc: aws },
      { name: "Google Cloud", imgSrc: gcloud },
    ],
  },
];

const Nineth = () => {
  return (
    <section className="nineth-d2c-section">
      <Container>
        <div className="text_wrap">
          <h2>
            We Ensure your <strong> Store's Success</strong>
          </h2>
          <p className="store-success-intro">
            Utilizing the latest D2C technologies and staying ahead of industry
            trends, we bring innovative solutions to drive your business
            forward.
          </p>
        </div>
        <div className="row nineth-d2c-main-row">
          <div className="col-12 nineth-d2c-main-col-1">
            <ul>
              {techData.map((techCategory, index) => (
                <li key={index}>
                  <div className="row tech-row first-tech-row">
                    <div className="col-12 col-lg-2 tech-col-1">
                      <h6>{techCategory.category}</h6>
                    </div>
                    <div className="col-12 col-lg-10 tech-col-2">
                      {techCategory.items.map((item, itemIndex) => (
                        <div className="tech-item" key={itemIndex}>
                          <div className="icon-border">
                            <img
                              src={item.imgSrc}
                              className="w-100"
                              alt={item.name}
                            />
                          </div>
                          <p>{item.name}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Nineth;
